import { Component, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { PageCloseButtonComponent } from "../../../../common/close-button/page-close-button.component";
import { TabType, VerticalTabsComponent } from "../../../../vertical-tabs/vertical-tabs.component";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgClass, NgForOf, NgIf } from "@angular/common";
import {
  TariffTableRulesComponent
} from "../../../tariff/tariff-table/tariff-table-rules/tariff-table-rules.component";
import { RightPanelComponent } from "../../../../right-panel/right-panel.component";
import { Rule } from "../../../../../models/tariff-rule-set";
import { DeterminantDetails } from "../../../../../models/determinant-details";
import { FinanceApiService } from "../../../../../services/finance-a-p-iervice.service";
import { LoadingService } from "../../../../../services/loading.service";
import { ToasterService } from "../../../../../services/toaster.service";
import { EditableTableComponent } from "../../../../editable-table/editable-table.component";
import { TableListRequest } from "../../../../../models/table-list-request.interface";
import { AutocompleteDropdownComponent } from "../../../../autocomplete-dropdown/autocomplete-dropdown.component";
import ChargeEditableTableConfig from "../../config/ChargesEditableTable.config.json";
import { EditableTableHeader } from "../../../../../models/editable-table-header.interface";
import { Charge } from "../../../../../models/charge.interface";
import { ActivatedRoute, Router } from "@angular/router";
import { AgreementConfigurationDTO } from "../../../../../models/customer-agreement.interface";
import { ResizableModule } from "angular-resizable-element";
import { TARIFF_ACTIONS, TariffActions, TariffService } from "../../../../../services/tariff.service";
import { ItemSelectorPanelComponent } from "../../../../item-selector-panel/item-selector-panel.component";
import { HorizontalTabsComponent } from "../../../../horizontal-tabs/horizontal-tabs.component";
import { ComingSoonComponent } from "../../../../coming-soon/coming-soon.component";
import { TariffComponent } from "../../../tariff/tariff.component";
import { ManageTariffComponent } from "../../../tariff/manage-tariff/manage-tariff.component";
import { ModalComponent } from "../../../../modal/modal.component";
import { AddAnotherDialogComponent } from "../../../../add-another-dialog/add-another-dialog.component";
import { NoDataComponent } from "../../../../no-data/no-data.component";
import { DeterminantType } from "../../../../../constants/finance-constants";

const TAB_IDS = {
  SETUP: "setup",
  TARIFF_AND_REBATE: "tariff_and_rebate",
  TARIFF: "tariff",
  REBATE: "rebate"
};

export const AGREEMENT_CONFIGURATION_ACTIONS = {
  ADD_NEW_AGREEMENT: "add-new",
  CONFIGURE_AGREEMENT: "configure",
  EDIT_AGREEMENT_CONFIGURATION: "edit",
  VIEW_AGREEMENT_CONFIGURATION: "view",
  DELETE_AGREEMENT_CONFIGURATION: "delete",
  CLONE_AGREEMENT_CONFIGURATION: "clone"
};

@Component({
  selector: "app-manage-agreement-configuration",
  standalone: true,
  imports: [
    PageCloseButtonComponent,
    VerticalTabsComponent,
    ReactiveFormsModule,
    NgClass,
    NgIf,
    NgForOf,
    EditableTableComponent,
    AutocompleteDropdownComponent,
    ResizableModule,
    ItemSelectorPanelComponent,
    HorizontalTabsComponent,
    ComingSoonComponent,
    TariffComponent,
    NoDataComponent
  ],
  templateUrl: "./manage-agreement-configuration.component.html",
  styleUrl: "./manage-agreement-configuration.component.scss"
})

export class ManageAgreementConfigurationComponent {
  protected readonly TAB_IDS = TAB_IDS;
  private _setupTabEdit: boolean = false;
  private _tariffRebateTabEdit: boolean = false;
  private _selectedVerticalTab: string = TAB_IDS.SETUP;
  private _selectedHorizontalTab: string = TAB_IDS.TARIFF;
  private _configurationId: string = "";

  protected readonly TARIFF_ACTIONS = TARIFF_ACTIONS;

  verticalTabs: TabType[] = [{
    id: TAB_IDS.SETUP,
    label: "Setup Configuration",
    subtitle: "Give the basic details",
    icon: "document_icon.svg",
    disabled: false
  },
    {
      id: TAB_IDS.TARIFF_AND_REBATE,
      label: "Special Tariff & Rebate",
      subtitle: "Define the rules for Tariff & Rebate",
      icon: "finance_menu_icon.svg",
      disabled: false
    }
  ];
  horizontalTabs: any[] = [{
    id: TAB_IDS.TARIFF,
    label: "Special Tariff"
  },
    {
      id: TAB_IDS.REBATE,
      label: "Rebate"
    }
  ];
  basicDetailsForm!: FormGroup;
  agreementChargeForm!: FormGroup;
  commonCriteria: Rule[] = [];
  allDeterminants: DeterminantDetails[] = [];
  chargesEditableTableConfig: EditableTableHeader[] = ChargeEditableTableConfig;
  chargesEditableTableData: any[] = [];
  customerAgreementId: string = "";
  currentAction: string = AGREEMENT_CONFIGURATION_ACTIONS.ADD_NEW_AGREEMENT;
  currentTariffAction: TariffActions = TARIFF_ACTIONS.LIST;
  agreementConfigurationData!: AgreementConfigurationDTO;
  selectedChargeIds: Set<string> = new Set<string>();

  @ViewChild("itemSelectorPanel") itemSelectorPanel!: ItemSelectorPanelComponent;
  @ViewChild("tariffAndRebateTemplate") tariffAndRebateTemplateRef!: TemplateRef<any>;


  constructor(private formBuilder: FormBuilder,
              private viewContainerRef: ViewContainerRef,
              private financeApiService: FinanceApiService,
              private loadingService: LoadingService,
              private toasterService: ToasterService,
              private router: Router,
              private route: ActivatedRoute,
              private tariffService: TariffService) {
    this.basicDetailsForm = this.formBuilder.group({
      priority: [1, [Validators.required]],
      description: ["", []]
    });

    this.agreementChargeForm = this.formBuilder.group({
      charge: [null, [Validators.required]]
    });
  }

  ngOnInit() {
    this.customerAgreementId = this.route.snapshot.params["agreementId"] || "";
    this.configurationId = this.route.snapshot.params["configurationId"] || "";
    this.tariffService.tariffActions$.subscribe({
      next: (data) => {
        this.handleTariffActions(data);
      }
    })
    this.setUpAppMode();
  }

  get setupTabEdit(): boolean {
    return this._setupTabEdit;
  }

  set setupTabEdit(value: boolean) {
    if (!value) {
      this.basicDetailsForm.disable();
      this.agreementChargeForm.disable();
    }
    this._setupTabEdit = value;
  }

  get tariffRebateTabEdit(): boolean {
    return this._tariffRebateTabEdit;
  }

  set tariffRebateTabEdit(value: boolean) {
    this._tariffRebateTabEdit = value;
  }

  get selectedVerticalTab(): string {
    return this._selectedVerticalTab;
  }

  set selectedVerticalTab(value: string) {
    const tab = this.getTabByTabId(value, this.verticalTabs);
    if(!tab){
      console.warn(`Invalid tab id: ${value}`);
      return
    }

    if(this.currentAction === AGREEMENT_CONFIGURATION_ACTIONS.EDIT_AGREEMENT_CONFIGURATION ||  this.currentAction === AGREEMENT_CONFIGURATION_ACTIONS.ADD_NEW_AGREEMENT){
      const tariffAndRebateTab = this.getTabByTabId(TAB_IDS.TARIFF_AND_REBATE, this.verticalTabs);
      Object.assign(tariffAndRebateTab,{disabled: true});
    }

    if (value === TAB_IDS.TARIFF_AND_REBATE) {
      setTimeout(() => {
        if (this.itemSelectorPanel) {
          const componentsToLoad = [{
            component: this.tariffAndRebateTemplateRef
          }];
          this.tariffService.updateState({routerNavigationAllowed: false})
          this.itemSelectorPanel.loadComponents(componentsToLoad);
        }
      });
    }
    this._selectedVerticalTab = value;
  }

  get selectedHorizontalTab(): string {
    return this._selectedHorizontalTab;
  }

  set selectedHorizontalTab(value: string) {
    this._selectedHorizontalTab = value;
  }

  get configurationId(): string {
    return this._configurationId;
  }

  set configurationId(value: string) {
    this.tariffService.updateState({agreementConfigurationId: value}) //set the value to the tariff sate
    this._configurationId = value;
  }

  goBack() {
    this.router.navigateByUrl(`/manage-finance/customer-agreement/${this.customerAgreementId}/configurations`);
  }

  handleTabSelected(tabId: string) {
    this.selectedVerticalTab = tabId;
  }

  async addRulesForCommonCriteria() {
    if (this.allDeterminants.length === 0) {
      await this.getAllDeterminants();
    }

    const panelComponentComponentRef = this.setUpRightPanelForCommonCriteria();

    const determinantRulesComponentRef = panelComponentComponentRef.instance.loadComponent(
      TariffTableRulesComponent
    );
    determinantRulesComponentRef.setInput("allDeterminants", this.allDeterminants);

    determinantRulesComponentRef.instance.patchRulesValueForCommonCriteria(this.commonCriteria);

    //check for apply all button of the right panel and then call the applyRules method of determinantRulesComponent
    panelComponentComponentRef.instance.primaryActionBtnEmitter.subscribe(() => {
      determinantRulesComponentRef.instance.applyRulesForCommonCriteria();
      if (determinantRulesComponentRef.instance.filterForm.valid) panelComponentComponentRef.destroy();
    });
    determinantRulesComponentRef.instance.applyAllButtonClicked.subscribe((commonCriteria: any) => {
      this.commonCriteria = commonCriteria;
    });
  }


  private setUpRightPanelForCommonCriteria() {
    const modalRef = this.viewContainerRef.createComponent(RightPanelComponent);
    modalRef.instance.title = "Add Rule";
    modalRef.instance.showActionBtns = true;
    modalRef.instance.primaryActionBtnText = "Apply";
    modalRef.instance.close.subscribe(() => {
      modalRef.destroy();
    });
    return modalRef;
  }

  private getAllDeterminants(): Promise<void> {


    return new Promise<void>((resolve, reject) => {
      this.financeApiService.getDeterminantDetails(DeterminantType.TARIFF).subscribe({
        next: res => {
          this.allDeterminants = res.data;
          resolve();
        },
        error: (error) => {
          this.toasterService.error(error.error.errorDesc);
          reject();
        }
      });
    });

  }

  getDisplayTextForDeterminant(determinantName: string | undefined) {
    return this.tariffService.getDisplayTextForDeterminant(determinantName, this.allDeterminants);
  }

  getDisplayTextForOperator(operatorValue: string | undefined) {
    return this.tariffService.getDisplayTextForOperator(operatorValue);
  }

  getValuesToPrint(rule: Rule) {
    return this.tariffService.getValuesToPrint(rule);
  }

  getChargeList() {
    return (chargeListRequest: TableListRequest) => this.financeApiService.getChargesList(chargeListRequest);
  }

  addCharges() {
    const chargeId = this.agreementChargeForm?.get("charge")?.value.key;

    if (!chargeId) return;


    this.financeApiService.getChargesById(chargeId).subscribe({
      next: (res) => {
        const chargeDetails: Charge = res.data;
        this.selectedChargeIds.add(chargeDetails.id)
        this.chargesEditableTableData.push({
          slNo: this.chargesEditableTableData.length + 1,
          ...chargeDetails,
          periodicCharge: false
        });
        this.agreementChargeForm?.reset();

      },
      error: (error: any) => {
        this.toasterService.error(error.error.errorDesc);
      }
    });
  }

  handleDataDeletion(data: any) {
    this.chargesEditableTableData.splice(data.rowIndex, 1);
    this.selectedChargeIds.delete(data?.record?.id)
    this.chargesEditableTableData.forEach((charge, index) => {
      charge.slNo = index + 1;
    });
  }

  saveAgreementConfiguration() {
    if(this.commonCriteria.length === 0){
      this.toasterService.error("Please add at least one billing rule");
      return;
    }

    if(this.chargesEditableTableData.length === 0){
      this.toasterService.error("Please add at least one charge");
      return;
    }

    this.basicDetailsForm.markAllAsTouched();
    if (this.basicDetailsForm.invalid) {
      return;
    }
    const agreementConfigurationDTO: AgreementConfigurationDTO = {
      ...this.basicDetailsForm.value,
      criteria: {
        rules: [...this.commonCriteria]
      },
      customerAgreementId: this.customerAgreementId,
      agreementCharges: {
        charges: this.chargesEditableTableData
      }
    };

    if (this.currentAction === AGREEMENT_CONFIGURATION_ACTIONS.ADD_NEW_AGREEMENT)
      this.callApiToSaveAgreement(agreementConfigurationDTO);
    else if (this.currentAction === AGREEMENT_CONFIGURATION_ACTIONS.EDIT_AGREEMENT_CONFIGURATION)
      this.callApiToEditConfiguration(this.customerAgreementId, this.configurationId, agreementConfigurationDTO);

  }

  private callApiToSaveAgreement(agreementConfigurationDTO: AgreementConfigurationDTO) {

    this.financeApiService.createAgreementConfiguration(this.customerAgreementId, agreementConfigurationDTO).subscribe({
      next: (res) => {
        this.showAddAddConfigurationsDialog();
        this.agreementConfigurationData = res.data;
        this.configurationId = res.data.id;
        this.toasterService.success("Agreement Created Successfully");

      },
      error: (error) => {
        this.toasterService.error(error.error.errorDesc);

      }
    });
  }

  private setUpAppMode() {
    this.currentAction = this.route.snapshot.url[0]?.path ?? AGREEMENT_CONFIGURATION_ACTIONS.ADD_NEW_AGREEMENT;
    switch (this.currentAction) {
      case AGREEMENT_CONFIGURATION_ACTIONS.ADD_NEW_AGREEMENT:
        this.selectedVerticalTab = TAB_IDS.SETUP;
        this.setupTabEdit = true;
        this.tariffRebateTabEdit = false;
        break;
      case AGREEMENT_CONFIGURATION_ACTIONS.CONFIGURE_AGREEMENT:
        this.selectedVerticalTab = TAB_IDS.TARIFF_AND_REBATE;
        this.setupTabEdit = false;
        this.tariffRebateTabEdit = true;
        this.setUpAppForViewAndEditMode();
        break;
      case AGREEMENT_CONFIGURATION_ACTIONS.EDIT_AGREEMENT_CONFIGURATION:
        this.selectedVerticalTab = TAB_IDS.SETUP;
        this.setupTabEdit = true;
        this.tariffRebateTabEdit = false;
        this.setUpAppForViewAndEditMode();
        break;
      case AGREEMENT_CONFIGURATION_ACTIONS.VIEW_AGREEMENT_CONFIGURATION:
        this.selectedVerticalTab = TAB_IDS.SETUP;
        this.setupTabEdit = false;
        this.tariffRebateTabEdit = false;
        this.setUpAppForViewAndEditMode();
        break;
    }
  }

  private setUpAppForViewAndEditMode() {
    this.loadingService.show()
    this.financeApiService.getAgreementConfiguration(this.customerAgreementId, this.configurationId).subscribe({
      next: (res) => {
        this.agreementConfigurationData = res.data;
        this.basicDetailsForm.patchValue({
          priority: this.agreementConfigurationData.priority,
          description: this.agreementConfigurationData.description
        });
        this.commonCriteria = [...this.agreementConfigurationData?.criteria?.rules];
        this.chargesEditableTableData = this.agreementConfigurationData?.agreementCharges?.charges.map((charge,index) => {
          if (charge.id != null) {
            this.selectedChargeIds.add(charge.id);
          }
          return {
            ...charge,
            slNo: index + 1
          };
        });
        this.loadingService.hide()
      },
      error: (error) => {
        this.loadingService.hide()
        this.toasterService.error(error.error.errorDesc);
      }
    });

  }

  private callApiToEditConfiguration(customerAgreementId: string, configurationId: string, agreementConfigurationDTO: AgreementConfigurationDTO) {
    this.financeApiService.editAgreementConfiguration(customerAgreementId, configurationId, agreementConfigurationDTO).subscribe({
      next: (res) => {
        this.showAddAddConfigurationsDialog();
        this.toasterService.success("Agreement Updated Successfully");
      },
      error: (error) => {
        this.toasterService.error(error.error.errorDesc);
      }
    });
  }

  protected readonly AGREEMENT_CONFIGURATION_ACTIONS = AGREEMENT_CONFIGURATION_ACTIONS;

  handleItemSelectorPanelSelection(event: { item: any; index: number }) {
    this.tariffService.updateState({ chargeId: event.item.id });
    const componentsToLoad = [{
      component: this.tariffAndRebateTemplateRef
    }];
    this.itemSelectorPanel?.loadComponents(componentsToLoad);
  }

  handleTariffActions(actions: TariffActions) {
    this.currentTariffAction = actions;
    switch (this.currentTariffAction) {
      case TARIFF_ACTIONS.ADD_NEW:
        this.createModalForTariffConfiguration();
        break;
      case TARIFF_ACTIONS.EDIT:
        this.tariffService.updateState({ appMode: TARIFF_ACTIONS.EDIT });
        this.createModalForTariffConfiguration();
        break;
      case TARIFF_ACTIONS.VIEW:
        this.tariffService.updateState({ appMode: TARIFF_ACTIONS.VIEW });
        this.createModalForTariffConfiguration();
        break;
      case TARIFF_ACTIONS.GO_BACK:
        if (this.closeModal) {
          this.closeModal({ refresh: true });
        }
        break;
    }
  }

  private showAddAddConfigurationsDialog() {
    const updateText = this.currentAction === AGREEMENT_CONFIGURATION_ACTIONS.EDIT_AGREEMENT_CONFIGURATION ? "Updated" : "Created";
    const modalRef = this.viewContainerRef.createComponent(ModalComponent);
    const confirmDialogRef = modalRef.instance.loadComponent(
      AddAnotherDialogComponent,
      {
        featureIconPath: "assets/icons/tick_add_another_dialog.svg",
        title: `Configuration ${updateText} Successfully.`,
        titleDescription: `The agreement has been successfully ${updateText}. Click 'Configure Tariff/Rebate' to set up tariffs and rebates.`,
        primaryBtnText: "Configure Tariff/Rebate"
      }
    );

    confirmDialogRef.instance.primaryBtnClickEmitter.subscribe(() => {
      this.router.navigateByUrl(`/manage-finance/customer-agreement/${this.customerAgreementId}/configurations/configure/${this.configurationId}`)
      modalRef.destroy();
    });

    confirmDialogRef.instance.secondaryBtnClickEmitter.subscribe(() => {
      this.goBack();
      modalRef.destroy();
    });

    modalRef.instance.close.subscribe(() => modalRef.destroy());
  }

  private createModalForTariffConfiguration() {
    const modalComponentComponentRef = this.viewContainerRef.createComponent(ModalComponent);
    modalComponentComponentRef.instance.width = "90vw";
    modalComponentComponentRef.instance.height = "90vh";

    this.tariffService.updateState({ routerNavigationAllowed: false });
    const componentRef = modalComponentComponentRef.instance.loadComponent(ManageTariffComponent);

    modalComponentComponentRef.instance.close.subscribe((res: any) => {
      if(res && res.refresh){
        this.selectedVerticalTab = TAB_IDS.TARIFF_AND_REBATE
      }
      modalComponentComponentRef.destroy();
    });

    this.closeModal = componentRef.instance.closeModal;
  }

  closeModal!: (params?: any) => void;

  close(params?: any) {
    if (this.closeModal) {
      this.closeModal(params);
    }
  }

  private getTabByTabId(tabId: string,tabs: TabType[]): any {
    return tabs.find((tab) => tab.id === tabId);
  }

  protected readonly Array = Array;
}
